import React from 'react';
import { Navigate } from 'react-router-dom';
import { useToken } from '../utils/token';

interface RequireAuthProps {
  children: React.ReactNode;
}

const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const token : any = useToken();
  if (token == null || token == undefined || token.token === undefined) {
    // Redirect to the login page if there is no token
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>; // Renders the children if the token exists
};

export default RequireAuth;
